import { Currency } from "@redotech/money/currencies";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { RedoFulfillmentLocation } from "@redotech/redo-fulfillment-group-common/fulfillment-location";
import { RedoShopifyCountryCode } from "@redotech/redo-inventory-common/fulfillment-country-code";
import type { ManualOrderFormValue } from "./manual-order-form";

/**
 * Default values for the "New shipment" slideout, pre-populated from a
 * fulfillment group so it starts with the order's items, address, and location.
 */
export function buildNewShipmentDefaults(
  group: FulfillmentGroupData,
  locations: readonly RedoFulfillmentLocation[] | undefined,
): Partial<ManualOrderFormValue> {
  const addr = group.destinationAddress;
  const location =
    locations?.find((loc) => loc.externalId === group.selectedLocationId) ??
    null;
  return {
    location,
    address: addr
      ? {
          name: addr.name ?? "",
          address1: addr.address1 ?? "",
          address2: addr.address2 ?? "",
          city: addr.city ?? "",
          company: addr.company ?? "",
          countryCode: addr.countryCode ?? RedoShopifyCountryCode.Us,
          email: addr.email ?? "",
          phone: addr.phone ?? "",
          province: addr.province ?? "",
          zip: addr.zip ?? "",
        }
      : undefined,
    orderInfo: {
      orderNumber: group.orders[0]?.name ?? "",
      orderDate: group.orderCreatedAt ?? new Date(),
      paidDate: new Date(),
      shippingPaid: { amount: "0", currency: Currency.USD },
      taxPaid: { amount: "0", currency: Currency.USD },
      totalPaid: { amount: "0", currency: Currency.USD },
      items: group.items.map((item) => ({ ...item })),
      internalNote: "",
    },
  };
}
